import { createFileRoute } from '@tanstack/react-router'
import { rentalBatchContractSearchSchema, RentalBatchEnterprisePage } from '@/features/order/index.ts'

export const Route = createFileRoute('/_authenticated/orders/rentals/materials/batch')({
  validateSearch: rentalBatchContractSearchSchema,
  component: BatchEnterprisePage,
  head: () => ({ meta: [{ title: '批量补齐资料 · Super Mega' }] })
})

function BatchEnterprisePage() {
  const { ids } = Route.useSearch()
  return <RentalBatchEnterprisePage key={ids.join(':')} ids={ids} />
}
